export default {"src":"/_next/static/media/TRON.22f228eb.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};